export const Accounts = {
  path: '/accounts',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'accounts',
      component: () => import('pages/accounts/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.accounts.name',
        path: '/accounts',
        condition: 'accounts',
      },
    },
    {
      path: 'create',
      name: 'accounts-create',
      component: () => import('pages/accounts/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.accounts.name',
            path: '/accounts',
            condition: 'accounts',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'accounts-id',
      component: () => import('src/pages/accounts/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.accounts.name',
            path: '/accounts',
            condition: 'accounts',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'accounts-id-edit',
      component: () => import('src/pages/accounts/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.accounts.name',
            path: '/accounts',
            condition: 'accounts',
          },
          {
            title: ':name',
            path: '/accounts/:id',
          },
        ],
      },
    },
  ],
};
